import axios from 'axios';

export const api2 = axios.create({
    baseURL: process.env.VUE_APP_BACKEND,
})

api2.interceptors.response.use(res => {
    return res;
}, err => {
    if(!err.response){
        err.response = {
            data: "Error de conexión con el servidor"
        }
    }
    return Promise.reject(err);
})
